  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-lg-4 vcenter">
      <h3>Manually Expended Inventory</h3>
    </div>
  </div>

  <hr style="margin-top: 2px; margin-bottom: 12px" />


  <aims-form [cols]="1">
    <aims-fc>
      <div class="table-container">
        <aims-common-table
          id="pulled-parts-table"
          [dataSource]="manuallyAttachedItems"
          [header]="partsTableHeader"
          [permissions]="partsTablePermissions"
          label="Pulled Inventory"
          pageSize="10"
          [footer]="true"
          hidePageSize="true"
          [stickyHeader]="true">

          <aims-common-table-dynamic-row id="quantity">
            <ng-template viewMode let-element >
              {{ getManualItemPulledQuantity(element.attachedItemId) }}
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="partCost">
            <ng-template viewMode let-element >
              {{ getManualItemPulledCost(element.attachedItemId) | currency: "USD":"symbol":"1.2-4" }}
            </ng-template>

            <ng-template aimsFooterTemplate let-element>
              {{ getTotalItemPulledCost() | currency: "USD":"symbol":"1.2-4" }}
            </ng-template>
          </aims-common-table-dynamic-row>

          <!-- sub-table -->
          <ng-template aimsCommonTableExpandedRow let-element>
            <mat-card >
            <aims-common-table
              label=""
              [id]="'pulled-detail-table-' + element.position"
              class="sub-table"
              [dataSource]="element.invAttachedItemPulled"
              [header]="partsSubTableHeader"
              [permissions]="{ filter: false, create: false, update: false, 'delete': false }"
              hidePageSize="true"
            >

              <aims-common-table-dynamic-row id="pulledByEmployeeId">
                <ng-template viewMode let-element >
                   {{ element.pulledByEmployeeId| getText:'employeeId':'fullName':employeeValues }}
                </ng-template>
              </aims-common-table-dynamic-row>

              <aims-common-table-dynamic-row id="unitCost">
                <ng-template viewMode let-element >
                  {{ element.inventoryItemReceived.costPerUnit | currency: "USD":"symbol":"1.2-4" }}
                </ng-template>
              </aims-common-table-dynamic-row>

            </aims-common-table>
            </mat-card>
          </ng-template>
        </aims-common-table>
      </div>
    </aims-fc>
  </aims-form>

  <aims-form [cols]="2" [spaceRows]="true">
    <aims-fc [labelColSize]="2" [controlColSize]="9">
        <mat-form-field appearance="fill">
          <textarea matInput
                  #aimsControl="ngModel"
                  name="Note"
                  placeholder="Note"
                  [ngModel]="manuallyExpended?.note"
                  maxlength="240"
                  readonly>
          </textarea>
      </mat-form-field>
    </aims-fc>

  </aims-form>
